export default __webpack_public_path__ + "static/media/clear-white.921721d3.svg";